export default __webpack_public_path__ + "static/media/company-selected.ad84e31d.svg";